let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hiDUx")).then(() => parcelRequire('1zDxH'));